import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderItemsTitle: {
    defaultMessage: 'Order Items',
    description: 'Header for the left panel showing unassigned order items',
    id: 'VxUNv7',
  },
  orderItemsInstruction: {
    defaultMessage: 'Drag items to a package to assign them for shipment.',
    description: 'Instruction text explaining how to assign items to packages',
    id: 'gaIXiD',
  },
  orderItemsCaption: {
    defaultMessage: 'Adjust quantities, then drag items to a package.',
    description: 'Caption text reminding users to assign all items before saving',
    id: 'q/bjGH',
  },
  allItemsAssigned: {
    defaultMessage: 'All Items Assigned!',
    description: 'Success message shown when all items have been assigned to packages',
    id: 'DDNIqR',
  },
});
